import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import c from './HelpContactUs.less';
import ContactUsModal from '../ContactUsModal/ContactUsModal';
import { responsive } from '../../helpers/view';

class HelpContactUs extends React.PureComponent {
  static propTypes = {
    subject: PropTypes.number,
  };

  static defaultProps = {
    subject: null,
  };

  state = {
    contactUsModalVisible: false,
  };

  handleToggleContactUs = () => {
    this.setState((state) => ({
      contactUsModalVisible: !state.contactUsModalVisible,
    }));
  };

  handleOpenContactUsModal = () => {
    const { subject } = this.props;
    if (responsive.isMobileOrTablet()) {
      this.props.history.push('/shop/contact', { defaultSubject: subject });
    } else {
      this.handleToggleContactUs();
    }
  };

  render() {
    return (
      <div className={c.container}>
        I have some other issue
        <button type="button" className={c.button} onClick={this.handleOpenContactUsModal}>Contact us</button>
        <ContactUsModal
          visible={this.state.contactUsModalVisible}
          onClose={this.handleToggleContactUs}
          defaultSubject={this.props.subject}
        />
      </div>
    );
  }
}

export default withRouter(HelpContactUs);
